var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import MenuButtonStyle, { MenuButtonTextStyle, MenuButtonTextWrapperStyle, } from './MenuButtonStyle';
const MenuButton = (_a) => {
    var { children, as } = _a, otherProps = __rest(_a, ["children", "as"]);
    return (React.createElement(MenuButtonStyle, Object.assign({ forwardedAs: as, iconSize: 14, variant: "blank" }, otherProps),
        React.createElement(MenuButtonTextWrapperStyle, null,
            React.createElement(MenuButtonTextStyle, null, children))));
};
export default MenuButton;
//# sourceMappingURL=MenuButton.js.map